import InputField from '../inputs/InputField';
import { inputChange } from './actions';
import { connect } from 'react-redux';
import { questionKey } from '../response/reducer';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    disabled: question.none,
    isValid:
      question.isValid ||
      question.fieldValids[ownProps.rowIndex] ||
      question.none,
    value: question.none ? '0' : question.rows[ownProps.rowIndex].value,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e =>
    dispatch(
      inputChange(e.target.value, ownProps.rowIndex, ownProps.questionId)
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(InputField);
